<template>
  <div class="pop-content">
    <span class="pop-title">Filter by ref. number</span>
    <ion-list>
      <template v-for="(idx,i) in filtersRefPop">
        <ion-item :key="'pop-indices-'+i" lines="none">
          <ion-label>{{ i }}</ion-label>
          <ion-checkbox
            slot="end"
            @ionChange="filtersRefPop[i] = !filtersRefPop[i]"
            :checked="filtersRefPop[i]"
          >
          </ion-checkbox>
        </ion-item>
      </template>
    </ion-list>
    <div class="pop-btn">
      <ion-button color="primary" expand="block" @click="filter">Filter</ion-button>
    </div>
  </div>
</template>

<script>
// import axios from "axios"
// import Vue from "vue"
export default {
  name: "PopoverFilters",
  props: {
    filtersRef: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      filtersRefPop: {},
    }
  },
  methods: {
    filter: function(success) {
      let response = {
        success,
        filtersRef: this.filtersRefPop,
      };
      this.$ionic.popoverController.dismiss(response);
    }
  },
  created: function() {
    this.filtersRefPop = JSON.parse(JSON.stringify(this.filtersRef))
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop-content {
  margin-top: 20px;
  text-align: left;
}

.pop-title {
  padding: 0 15px;
}

.pop-btn {
  padding: 0 12px 10px;
}

.pop-light-wrapper {
  padding: 10px 12px 20px;
}

.pop-light-wrapper > div {
  cursor: pointer;
}
</style>